export default class Services {
    constructor() {
        const services = document.querySelectorAll(
            '[data-behaviour="service"]',
        );
        if (services.length > 0) {
            function checkIsTouchDevice() {
                return (
                    'ontouchstart' in window ||
                    navigator.maxTouchPoints > 0 ||
                    navigator.msMaxTouchPoints > 0
                );
            }

            let curService = null;
            const overlays = document.querySelectorAll(
                '[data-behaviour="service-overlay"]',
            );
            const isTouch = checkIsTouchDevice();

            function swapActive(ref) {
                // make all other overlays except this one inactive
                overlays.forEach((overlay) => {
                    if (overlay.dataset.ref == ref) {
                        overlay.classList.add('active');
                    } else {
                        overlay.classList.remove('active');
                    }
                });
                // make all other services except this one inactive
                services.forEach((services2) => {
                    if (services2.dataset.ref == ref) {
                        services2.classList.add('active');
                    } else {
                        services2.classList.remove('active');
                    }
                });
            }

            services.forEach((service) => {
                // allow click anywhere to activate the main link (so that further inner links can be clicked)
                service.addEventListener('click', (ev) => {
                    if (ev.target.tagName.toLowerCase() === 'a') {
                        return;
                    }
                    ev.preventDefault();
                    // go to the link if we're not on touch, or if it's the active item
                    if (!isTouch || service.classList.contains('active')) {
                        window.location.href = service.dataset.link;
                    } else if (isTouch) {
                        // if we're on a touch device and this item wasn't active, open this one up first
                        swapActive(service.dataset.ref);
                    }
                });
                // for desktop, make the service active on hover
                if (!isTouch) {
                    service.addEventListener('mouseover', (ev) => {
                        const ref = service.dataset.ref;
                        // if we've hovered over a new service, make it active
                        if (curService != ref) {
                            curService = ref;
                            swapActive(ref);
                        }
                    });
                }
            });
        }
    }
}
